import rootActions from "../rootActions";

class customerSubscriptionActions extends rootActions {
  constructor(params) {
    super(params);
  }
}

export default customerSubscriptionActions;
